/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {TableColumnAlignEnum, TableColumnEnum, TableColumnInterface, TableIconEnum} from '@shared/components/table';

/**
 * @description
 * Locations header config
 */
export const LOCATIONS_HEADERS: TableColumnInterface[] = [
  {
    field: 'name',
    type: TableColumnEnum.text,
    header: 'app.setting.location.fields.name.label',
    align: TableColumnAlignEnum.center,
    grow: 2,
    sort: true,
  },
  {
    field: 'description',
    type: TableColumnEnum.icon,
    header: 'app.setting.location.fields.description.label',
    align: TableColumnAlignEnum.center,
    grow: 2,
    dualIcon: [TableIconEnum.file, TableIconEnum.fileSlash],
  },
  {
    field: 'latitude',
    type: TableColumnEnum.text,
    header: 'app.setting.location.fields.lat.label',
    align: TableColumnAlignEnum.center,
  },
  {
    field: 'longitude',
    type: TableColumnEnum.text,
    header: 'app.setting.location.fields.lng.label',
    align: TableColumnAlignEnum.center,
  },
]
